/**
 * Pictogramme d’élément.
 *
 * La forme diffère d’un élément à l’autre (triangle, disque, carré, losange) **en plus** de la
 * couleur : la DA ne repose jamais sur la seule teinte (palettes M1-04, accessibilité daltonisme).
 * Le nom de l’élément est toujours affiché à côté par l’appelant : le pictogramme est donc
 * décoratif et masqué aux technologies d’assistance.
 */
import type { Element } from '@elemora/shared/content';

const FORMES: Readonly<Record<Element, string>> = {
  /** Triangle : la flamme. */
  feu: 'M12 3 21 20 3 20Z',
  /** Disque : la goutte. */
  eau: 'M12 3a9 9 0 1 0 0.01 0Z',
  /** Carré : le bloc de terre. */
  terre: 'M4 5h16v14H4Z',
  /** Losange : le courant d’air. */
  air: 'M12 2 22 12 12 22 2 12Z',
};

export interface ProprietesIconeElement {
  readonly element: Element;
}

export function IconeElement({ element }: ProprietesIconeElement) {
  return (
    <svg
      className={`icone icone--${element}`}
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
      focusable="false"
    >
      <path d={FORMES[element]} fill="currentColor" />
    </svg>
  );
}
